import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './LivePulse.css';

/**
 * Wraps a live-updating value with optional continuous pulse and a brief flash on change.
 */
const LivePulseValue = ({ value, children, className = '', pulse = false }) => {
  const prevRef = useRef(value);
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    const previous = prevRef.current;
    const hasPrevious = previous !== undefined && previous !== null && previous !== '';
    const hasCurrent = value !== undefined && value !== null && value !== '';

    if (hasPrevious && hasCurrent && previous !== value) {
      setFlash(true);
      const timer = setTimeout(() => setFlash(false), 650);
      prevRef.current = value;
      return () => clearTimeout(timer);
    }

    prevRef.current = value;
  }, [value]);

  const classes = [
    className,
    pulse ? 'live-pulse-active' : '',
    flash ? 'live-value-flash' : '',
  ].filter(Boolean).join(' ');

  return (
    <span className={classes || undefined}>
      {children ?? value}
    </span>
  );
};

LivePulseValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  className: PropTypes.string,
  pulse: PropTypes.bool,
};

export default LivePulseValue;
